
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import ModalWindow from '@/components/molecules/ModalWindow.vue'
import { LoginHistory } from '@/models/LoginHistory'
import DateUtils from '@/utils/DateUtils'

/**
 * ログイン履歴モーダル
 */
@Component({
  components: {
    ModalWindow,
  },
})
export default class ModalLoginHistory extends Vue {
  /** モーダルウィンドウ */
  @Ref()
  modalWindow!: ModalWindow

  /** ログイン履歴一覧 */
  @Prop()
  private loginHistoryList!: LoginHistory[]

  /**
   * 日付のフォーマット
   *
   * @param date 日付(Date型)
   * @returns フォーマットされた日付
   */
  private formatDate(date: Date): string {
    return DateUtils.format(date, false)
  }

  /**
   * モーダルを開く
   */
  public show(): void {
    this.modalWindow.show()
  }
}
